import { configureStore } from "@reduxjs/toolkit";
import syncAssetIDSliceReducer from "./slices/groupExplorerActiveAssetID";

export const store = configureStore({
  reducer: {
    groupExplorerActiveAssetID: syncAssetIDSliceReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
